import { GridRowId } from '@mui/x-data-grid/models/gridRows';

export interface ResponseObject<Type> {
    errorStatusCode: number | null;
    response: Type;
}

export interface PagingObject<Type> {
    nodes: Type[];
    totalCount: number;
    pageInfo: PageInfo;
}

export interface PageInfo {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string;
    endCursor: string;
}

export interface PaginationModel {
    pageSize: number;
    page: number;
}

export type SortModel = {
    field: string;
    sort: 'asc' | 'desc';
};

export enum cursorTypes {
    first = 'first',
    last = 'last',
}

export interface QueryOptions {
    cursor: GridRowId;
    pageSize: number;
    searchFilter: string;
    sortModel: SortModel | null;
}

export interface UserInfo {
    token?: string;
}
